import { useState, useEffect, useCallback } from 'react';
import { useMountedState } from 'react-use';
import { useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { fetchKnmTypes } from 'APIPackage/CatalogsModule/services/knmTypesApi';
import { IKnmType } from 'APIPackage/CatalogsModule/interfaces/IKnmType';
import { coreSetLoading } from 'CorePackage/MainModule/actions/coreActions';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';

import { createKnmTypeSelectOption } from '../common/createKnmTypeSelectOption';
import { IKnmTypeSelectOption } from '../interfaces/IKnmTypeSelectOption';

export function useKnmTypes(isErknm?: boolean) {
  const isMounted = useMountedState();
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const [knmTypes, setKnmTypes] = useState<IKnmType[]>([]);
  const [knmTypesSelectOptions, setKnmTypesSelectOptions] = useState<IKnmTypeSelectOption[]>([]);

  const refresh = useCallback(async () => {
    try {
      dispatch(coreSetLoading(true));
      const types = await fetchKnmTypes(isErknm);

      if (isMounted()) {
        setKnmTypes(types);
      }
    } finally {
      dispatch(coreSetLoading(false));
    }
  }, [dispatch, isErknm, isMounted]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    setKnmTypesSelectOptions(knmTypes.map(knmType => createKnmTypeSelectOption(knmType)));
  }, [knmTypes]);

  return {
    refresh,
    knmTypes,
    knmTypesSelectOptions,
  };
}
